import Link from "next/link"
import Image from "components/Image"
import storyblokImageLoader from "utilities/storyblokImageLoader"

export default function BlogCard({ name, image, slug }) {
  return (
    <div className="border-0.5 border-grey-cool bg-white flex flex-col h-full">
      <Link href={slug} replace>
        <Image
          loader={image?.filename && image?.filename !== "" ? storyblokImageLoader : undefined}
          src={image?.filename && image?.filename !== "" ? image.filename : "/assets/placeholder.png"}
          alt={image?.alt ? image?.alt : name}
          placeholder={image?.blurDataURL ? "blur" : "empty"}
          blurDataURL={image?.blurDataURL}
          width={299}
          height={153}
          className="w-full aspect-[2/1] object-cover"
          sizes="(max-width: 1024px) 45vw, (max-width: 640px) 95vw, 20vw"
        />
      </Link>
      <div className="py-7 px-4 xl:px-7 flex flex-col justify-center h-full">
        <Link className="bracket-link block w-full mr-8" href={slug} replace>
          <h2 className="text-m1 font-semibold text-primary text-center">{name}</h2>
        </Link>
      </div>
    </div>
  )
}
